import React, { FC } from 'react'
import Modal from '@vtex/styleguide/lib/Modal'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

export type RequiredInformationProps = {
  isOpen: boolean
  content: string
  title: string
  onClose: () => void
  onFillActionClick: () => void
}

const RequiredInformation: FC<RequiredInformationProps> = ({
  isOpen,
  content,
  title,
  onClose,
  onFillActionClick,
}) => {
  const modalTitle = <FormattedMessage id={title} />

  const handleActionClick = () => {
    onFillActionClick()
    onClose()
  }

  return (
    <Modal centered title={modalTitle} isOpen={isOpen} onClose={onClose}>
      <div data-testid="modal-required-information" className="nb5">
        <span>
          <FormattedMessage id={content} />
        </span>
        <div className="flex justify-end mt6">
          <Button
            testId="required-information-fill"
            type="submit"
            variation="primary"
            onClick={handleActionClick}
          >
            <FormattedMessage id={'requiredInformationAction'} />
          </Button>
        </div>
      </div>
    </Modal>
  )
}

const RequiredInformationMemoized = React.memo(RequiredInformation)

export { RequiredInformationMemoized as RequiredInformation }
